<template>
<div class="flat-view">
    <amf-form class="container" :title="'Team Management'">
        <div class="container">
            <div class="row mt-4 p-0">
                <div class="flex-row flex-nowrap mb-1 col-12">
                    <amf-select :label="'Team Name'" v-model="selectedTeamId" :options="teams" show-label class="pl-1"/>
                </div>
            </div>
            <template v-if="selectedTeam">
                <div class="row mt-4 p-0">
                    <div class="flex-row flex-nowrap mb-1 col-12">
                        <div class="title">Team Manager: {{ fullName(selectedTeam.manager) }}</div><br/>
                    </div>
                </div>
                <div class="row mt-4 p-0">
                    <div class="flex-row flex-nowrap mb-1 col-12">
                        <table class="mt-2 table table-sm table-condensed table-hover">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="member in selectedTeam.members" :key="member.teamMemberId">
                                    <td>
                                        <span v-if="member.user && !member.user.isApproved" class="fa fa-ban"></span>
                                        <span>{{ fullName(member.user) }}</span>
                                    </td>
                                    <td>{{ member.user.email }}</td>
                                    <td>
                                        <a v-if="can.editTeam" href="#" @click.prevent="removeUser(member.user)">Remove from Team</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </div>
    </amf-form>
</div>
</template>

<script>
function mapUserSelect(user) {
    return { id: user.userId, name: `${user.firstName} ${user.lastName} - ${user.email}` }
}

import { modalService } from '../framework';
import { romeApi } from '../framework/utils/rome-api';
    export default {
        data() {
            return {
                users: [],
                teams: [],
                members: [],
                selectedTeamId: null,
                amfOptions: {noTracking: true}
            }
        },
        computed: {
            menuItems() {
                return ['Assign Team Manager', 'Add Team Member'];
            },
            selectedTeam() {
                if(this.selectedTeamId) {
                    return this.teams.find(t => t.teamId == this.selectedTeamId);
                }
            },
            managers() {
                return this.users.filter(u => u.manager);
            }
        },
        async created() {
            await this.load();
            this.selectedTeamId = this.teams[0].teamId;
        },
        methods: {
            async removeUser(member) {
                let ok = await modalService.confirm(`Are you sure you want to remove ${member.firstName} ${member.lastName} from the team?`);
                if(ok) {
                    await romeApi.delete(`team/${this.selectedTeamId}/user/${member.userId}`);
                    await this.load();
                }
            },
            async assignTeamManager() {
                let userId = this.selectedTeam.teamManagerId;
                let managers = this.users.filter(u => u.manager && u.isApproved).map(mapUserSelect);

                let teamManager = await modalService.select('Select Team Manager', userId, managers, 'Assign Team Manager');
                if(!teamManager) return;
                if(teamManager) {
                    await romeApi.post(`team/${this.selectedTeamId}/manager/${teamManager}`);
                    await this.load();
                }
            },
            async addTeamMember() {
                let users = this.users.filter(u => !u.manager && u.isApproved).map(mapUserSelect);
                let member = await modalService.select('Select Team Member', null, users, 'Assign Team Member');
                if(!member) return;

                await romeApi.post(`team/${this.selectedTeam.teamId}/user/${member}`);
                await this.load();
            },
            async load() {
                let teams = await romeApi.get(`team`);
                let members = await romeApi.get(`team/member`);
                let cxsUsers = await romeApi.get(`user`, { role: 'ae', page: 1, pageSize: 1000 });
                let cxmUsers = await romeApi.get(`user`, { role: 'teammanager', page: 1, pageSize: 1000 });

                this.users = cxmUsers.map(u => { u.manager = true; return u; });
                this.users = this.users.concat(cxsUsers.map(u => { u.manager = false; return u; }));

                members.forEach(member => {
                    member.user = this.users.find(u => u.userId == member.teamMemberId);
                });

                teams.forEach(team => {
                    team.manager = this.users.find(u => u.userId == team.teamManagerId);
                    team.managerAe = this.users.find(u => u.userId == team.teamManagerAeUser);
                    team.members = members.filter(m => m.teamId == team.teamId && m.user);
                    team.id = team.teamId;
                    team.name = team.teamName;
                });

                this.members = members;
                this.teams = teams;
            },
            fullName(user) {
              return `${user.firstName} ${user.lastName}`;
            }
        }
    }
</script>

<style lang="scss" scoped>
.title {
    font-size: 1.35em;
}
</style>



// WEBPACK FOOTER //
// src/user/Teams.vue